import { css, Global } from "@emotion/react";
import theme from "@theme";

const inputStyles = css`
  .Mui-selected {
    color: black !important;
    font-weight: bold;
  }

  .MuiTabs-indicator {
    background-color: #c44f27 !important;
  }
`;

const GlobalStyles = () => <Global styles={inputStyles} />;

const SC = {
  GlobalStyles,
};
export default SC;
